import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 95.78 95.78"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M.67 55.82a47.442 47.442 0 0 0 6.74 17.65C19.77 70.03 30.63 63.52 34.49 49c4.25-15.98-.6-32.72-12.2-41.59C6.49 17.41-2.62 36.23.67 55.82m94.44-15.86c4.38 26.08-13.2 50.77-39.29 55.15-4.39.74-8.74.85-12.95.41C29.26 94.1 17 86.87 9.11 76l77.53-22.23c1.11-.32.83-1.39-.09-1.33l-32.5 2.27c4.58-4.42 8.06-9.84 7.64-17.34-.86-12.14-13.22-23.99-36.2-31.79 4.42-2.34 9.27-4.03 14.47-4.91 4.39-.73 8.74-.85 12.95-.41 20.86 2.18 38.56 18 42.2 39.7",
      style: {"fill":"#c70a0c"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "TK-logo"}) } }